<template>
  <div>
    <div v-show="detalhamento_categoria.cobertura_manual_categoria > 0">
      <p class="ma-0 font-weight-medium">
        Cobertura manual
      </p>
      <p class="ma-0 mt-n1">
        {{ `${Helpers.formatarValor(detalhamento_categoria.cobertura_manual_categoria)} dias` }}
        <v-icon small class="mt-n1" @click="dialog_ativo = true">mdi-pencil</v-icon>
      </p>
    </div>

    <v-dialog
      v-model="dialog_ativo"
      width="400"
      content-class="bra-20"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title>
          <span>Cobertura de estoque manual</span>

          <v-spacer />

          <v-btn icon @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-5">
          <TextFieldFormatadorDeValor
            v-model="cobertura_manual_dias"
            outlined
            :max-digitos="0"
            label="Qtd. dias"
            suffix="dias"
            :error-messages="COBERTURA_ERRORS"
            @focus="$event.target.select()"
            @keyup.enter="salvarCoberturaManual()"
          />
        </v-card-text>

        <v-card-actions class="mt-n5">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="salvarCoberturaManual()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TextFieldFormatadorDeValor from '../../../utils/TextFieldFormatadorDeValor.vue';
import {required, minValue} from "vuelidate/lib/validators";
import {mapGetters} from "vuex";
import {parametros_rota} from "../helpers/ParametrosRota";
import {salvarCoberturaManual} from "../../../../api/compraPorDepartamentos/Categoria";
import {logout} from "../../../../helpers";

export default {
  name: "CoberturaManual",
  mixins: [parametros_rota],
  components: { TextFieldFormatadorDeValor },
  props: {
    detalhamento_categoria: Object
  },
  data: () => ({
    dialog_ativo: false,
    cobertura_manual_dias: 0
  }),
  validations: {
    cobertura_manual_dias: {
      required,
      minValue: minValue(1),
    }
  },
  computed: {
    ...mapGetters({
      'callbackAtualizarTabelaCategorias': 'comprasPorDepartamentos/callbackAtualizarTabelaCategorias',
      'callbackAtualizarCardsTotais': 'comprasPorDepartamentos/callbackAtualizarCardsTotais',
      'callbackAtualizarDetalhesCategoria': 'comprasPorDepartamentos/callbackAtualizarDetalhesCategoria',
    }),
    COBERTURA_ERRORS() {
      const errors = [];
      if (!this.$v.cobertura_manual_dias.$dirty) return errors;
      !this.$v.cobertura_manual_dias.required && errors.push("Campo Obrigatório.");
      !this.$v.cobertura_manual_dias.minValue && errors.push("Valor mínimo é 1.");
      return errors;
    }
  },
  watch: {
    dialog_ativo(valor) {
      if (valor) {
        const obj = Object.assign({}, this.detalhamento_categoria);
        this.cobertura_manual_dias = obj.cobertura_manual_categoria;
      }
    }
  },
  methods: {
    salvarCoberturaManual() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const parametros = {
        grupo: this.grupo_compra,
        idcategoria: this.detalhamento_categoria.idcategoria,
        cobertura_manual_dias: parseFloat(this.cobertura_manual_dias)
      };

      this.$store.dispatch('loading/addRequisicao',
        salvarCoberturaManual(parametros)
          .then(() => {
            this.dialog_ativo = false;
            this.callbackAtualizarTabelaCategorias();
            this.callbackAtualizarCardsTotais();
            this.callbackAtualizarDetalhesCategoria();
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
